if ($('.id-2627, .id-2636, .id-2901, .id-2630, .id-2633, .id-2639, .id-2642, .id-2645, .id-2651').length) {
    function addReadMoreBtn() {
        $('.news-item').each(function () {
            var $item = $(this);
            var link = $item.find('a.title').attr('href');
            if ($item.find('.read-more').length) return;

            if (link) {
                $item.find('.description').append(
                    $('<a>', {
                        href: link,
                        text: 'Přečíst celý článek',
                        class: 'read-more'
                    })
                );
            }
        });
    }

    $(document).ready(function () {
        addReadMoreBtn();
    });

    document.addEventListener('ShoptetPagePaginationUsed', function () {
        document.addEventListener('ShoptetDOMPageContentLoaded', function handler() {
            addReadMoreBtn();
            document.removeEventListener('ShoptetDOMPageContentLoaded', handler);
        });
    });

}